export class TemplateValidationError extends Error {
  public readonly issues: string[];

  constructor(issues: string[]) {
    super(`Template validation failed with ${issues.length} issue(s).`);
    this.name = "TemplateValidationError";
    this.issues = issues;
  }
}

export class SchemaVersionError extends Error {
  public readonly expected: string;
  public readonly received: unknown;

  constructor(expected: string, received: unknown) {
    super(
      `Unsupported template schema version. Expected '${expected}', received '${String(received)}'.`,
    );
    this.name = "SchemaVersionError";
    this.expected = expected;
    this.received = received;
  }
}

export class MissingVariableError extends Error {
  public readonly missingPaths: string[];

  constructor(missingPaths: string[]) {
    super(`Missing required variable(s): ${missingPaths.join(", ")}`);
    this.name = "MissingVariableError";
    this.missingPaths = missingPaths;
  }
}

export class RenderLayoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "RenderLayoutError";
  }
}
